import ResearchSection from "./ResearchSection"
import EducationSection from "./EducationSection"
import AwardSection from "./AwardSection"

export {
  ResearchSection,
  EducationSection,
  AwardSection
}